export const renderClientName = (client) => {
    return client
        ? `${client?.code ? `(${client?.code}) ` : ''}${client?.firstName ? `${client?.firstName}` : ''}${client?.middleName ? ` ${client?.middleName?.slice(0, 1)}.` : ''}${client?.lastName ? ` ${client?.lastName}` : ''}`
        : '--';
};

export const renderStaffName = (staff) => {
    return staff
        ? `${staff?.firstName ? staff?.firstName : ''}${staff?.middleName ? ` ${staff?.middleName?.slice(0, 1)}.` : ''}${staff?.lastName ? ` ${staff?.lastName}` : ''}`
        : '--';
};
